import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10986d40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "platform__title" }
const _hoisted_2 = { class: "platform__content" }
const _hoisted_3 = { class: "platform__description" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "btn-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ms_store_badge = _resolveComponent("ms-store-badge")!

  return (_ctx.GlobalStore.isWindowsOs)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["platform", { active: _ctx.isActive }])
      }, [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('platformWindows.title')), 1),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('platformWindows.description')), 1),
          _createElementVNode("a", {
            href: _ctx.appData.fallbackLink,
            class: "platform__btn btn btn--primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addToApps && _ctx.addToApps(...args)))
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('platformWindows.addToApps')), 1)
          ], 8, _hoisted_4),
          _createElementVNode("div", {
            style: _normalizeStyle({display: `${_ctx.showInstall ? 'block' : 'none'}`}),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyAppUrl && _ctx.copyAppUrl(...args)))
          }, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('platformWindows.notInstalledYet')), 1),
            _createTextVNode(),
            _hoisted_8,
            _createVNode(_component_ms_store_badge, {
              productid: "9N4KL7JFS0V9",
              "window-mode": "full",
              theme: "auto",
              language: "en"
            })
          ], 4)
        ], 512), [
          [_vShow, _ctx.isActive]
        ])
      ], 2))
    : _createCommentVNode("", true)
}